import { PropsWithChildren } from 'react'

import { SubSectionContainer } from './SubSectionContainer'

export const RegionWithLabel = (props: PropsWithChildren<{ ['data-testid']?: string; ariaLabelledBy: string }>) => {
  return (
    <SubSectionContainer {...props} aria-labelledby={props.ariaLabelledBy}>
      {props.children}
    </SubSectionContainer>
  )
}
